
import { Component, ChangeDetectionStrategy, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { QdmService, Restaurant } from "app/Services/qdm.service";

@Component({
    host: {
        class: "w-full h-full flex items-center justify-center"
    },
    selector: "no-mealmoments-error-page",
    template: `
    <div class="w-full h-full flex items-center justify-center">
      <div
        class="flex items-center justify-center w-full h-full px-2">
        <div
          class="modalNoPerio relative bg-noir-1 w-full max-w-[600px] pr-0 md:pr-32 text-white h-full max-h-[25rem] rounded flex flex-col shadow-xl overflow-y-auto py-4 px-2">
          <img alt="" class="w-16 mx-auto my-4 animate-[pulse_1s_ease_infinite]" src="/assets/images/icons/alert_sign.svg">
    
          <p class="font-semibold w-full text-center my-2">Commande indisponible</p>
          <p class="font-medium w-full text-center mt-2 px-4 text-sm">
            La commande pour ce restaurant n'est pas disponible car aucun moment repas n'a été renseigné.
          </p>
    
          @if ((this.restaurant?.phone || '').length > 0) {
            <div class="my-auto flex w-full gap-2 px-4 text-xs items-center">
              <span class="material-icons">
                phone
              </span>
              <a [href]="'tel:' + ($safeNavigationMigration(this.restaurant?.phone))" class="font-semibold underline">{{ this.restaurant?.phone }}</a>
            </div>
          }
          @if ((this.restaurant?.email || '').length > 0) {
            <div class="flex w-full gap-2 px-4 text-xs items-center">
              <span class="material-icons">
                mail
              </span>
              <a [href]="'mailto:' + ($safeNavigationMigration(this.restaurant?.email))" class="font-semibold underline">{{ this.restaurant?.email }}</a>
            </div>
          }
    
          <div class="mt-2 w-full flex flex-col px-6 mt-auto">
            <button
              (click)="this.router.navigate(['/'])"
              class="hover:bg-gris-3 btn btn-primary flex gap-4 h-full items-center px-2 rounded w-full justify-center bg-white font-semibold transition-all duration-200 ease-in-out border-2 border-gray-200 overflow-hidden h-[40px] text-[#383737]"
              style="height: 40px;">
              <span class="material-icons"> keyboard_arrow_left </span>
              <p>Retour aux restaurants</p>
            </button>
          </div>
    
          <img src="/assets/images/humans/portrait-chef-cook-holding-fast-food-burger_23-2151004503 1.webp" class="hidden md:block w-48 absolute right-0 bottom-0" />
        </div>
      </div>
    </div>
    
    
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class NoMealMomentsErrorPageComponent {
    protected route = inject(ActivatedRoute);
    protected router = inject(Router);
    protected qdm = inject(QdmService);


    restaurant?: Restaurant;


    ngOnInit(): void {
        this.restaurant = this.qdm.selectedRestaurantSubject.value;

        if(!this.restaurant){
            this.router.navigate(["/"]);
        }
    }
}